/** 路由入口 */
import { createBrowserRouter } from 'k-soup/router/browser';
import { createRoutes } from 'k-soup/router';
import { AppLoading } from '@/components/AppLoading';
import { routes } from './config';

const routeObjects = createRoutes({
  routes,
  fallback: <AppLoading />,
});

export const router = createBrowserRouter(routeObjects);
